import router from "@/router"

export function redirectToLogin () {
  router.replace('/login')
}
